<template>

<div>

  <LDBsTable
    url="user"
    defaultSort="name"
    defaultOrder="asc"
    :query="queryToUse"
    :columns="columns"
    :clear="clear"
    :defaultOptions='options'
  >
    <div class="form-group col-lg-4">
      <label for="name">{{ $t('name') }}</label>
      <input
        type="text"
        id="name"
        name="name"
        class="form-control"
        :placeholder="$t('type_name')"
        v-model="query.name"
        v-validate="'required'"
      >
    </div>

    <div class="form-group col-lg-4">
      <label for="email">{{ $t('email') }}</label>
        <input
          type="email"
          class="form-control"
          id="email"
          name="email"
          :placeholder="$t('type_email')"
          v-model="query.email"
          v-validate="'required|email'"
        >
    </div>

    <div class="form-group col-lg-4">
      <label for="company">{{ $t('company') }}</label>
        <Combobox
          class="bg-white"
          name='company'
          :placeholder="$t('select_a_item')"
          label="name"
          :options="companies"
          :initial-value="query.company"
          v-model="query.company"
          :reduce="company => company.id"
        />
    </div>

    <div class="form-group col-lg-4">
      <label for="usertype">{{ $t('usertype') }}</label>
        <Combobox
          class="bg-white"
          name='usertype'
          :placeholder="$t('select_a_item')"
          label="name"
          :options="usertypes"
          :initial-value="query.type"
          v-model="query.type"
          :reduce="usertype => usertype.id"
        />
    </div>

    <div class="form-group col-lg-4">
      <label for="admin">{{ $t('admin') }}</label>
        <Combobox
          class="bg-white"
          name='admin'
          :placeholder="$t('select_a_item')"
          label="label"
          :options="[{ label: 'SIM', value: true }, { label: 'NÃO', value: false }]"
          :initial-value="query.admin"
          v-model="query.admin"
          :reduce="admin => admin.value"
        />
    </div>

    <div class="form-group col-lg-4">
      <label for="isActive">{{ $t('active') }}</label>
        <Combobox
          class="bg-white"
          name='isActive'
          :placeholder="$t('select_a_item')"
          label="label"
          :options="[{ label: 'SIM', value: true }, { label: 'NÃO', value: false }]"
          :initial-value="query.isActive"
          v-model="query.isActive"
          :reduce="isActive => isActive.value"
        />
    </div>
  </LDBsTable>

</div>

</template>

<script>
import { mapState } from 'vuex'
import LDBsTable from '@/components/shared/LDBsTable'
import Combobox from '@/components/shared/ComboBox'

export default {
  name: 'UsersList',
  components: {
    LDBsTable,
    Combobox
  },

  data () {
    return {
      columns: [
        {
          title: this.$t('name'),
          field: 'name',
          sortable: true
        },
        {
          title: this.$t('email'),
          field: 'email',
          sortable: true
        },
        {
          title: this.$t('company'),
          field: 'company',
          formatter: function(value) {
            return value
              ? value.name
              : '-'
          },
          sortable: true
        },
        {
          title: this.$t('usertype'),
          field: 'type',
          formatter: function(value) {
            return value
              ? value.name
              : '-'
          },
          sortable: true
        },
        {
          title: this.$t('admin'),
          field: 'admin',
          formatter: function (value) {
            return value ? 'SIM' : 'NÃO'
          },
          sortable: true
        },
        {
          title: this.$t('active'),
          field: 'isActive',
          formatter: function (value) {
            return value ? 'SIM' : 'NÃO'
          },
          sortable: true
        },
        {
          key: 'id',
          field: 'id',
          align: 'center',
          align: 'center',
          width: '100%',
          formatter: function (value) {
            return `<a href="#/main/users/${value}" class="edit btn btn-action btn-primary btn-circle light-bottom-shadow text-white"><i class="fas fa-pen"></i></a>`
          },
        }
      ],
      options: {
        exportOptions: { fileName: 'usuarios' }
      },
      query: {
        id: '',
        name: '',
        email: '',
        company: '',
        admin: '',
        type: '',
        isActive: undefined
      },
      queryToUse: {}
    }
  },

  computed: {
    ...mapState({
      companies: state => state.company.all,
      usertypes: state => state.usertypes.all,
      lastquery: state => state.filtershistory.query
    })
  },

  methods: {
    clear() {
      this.query.name = '',
      this.query.email = '',
      this.query.company = '',
      this.query.type = '',
      this.query.admin = '',
      this.query.isActive = undefined
    }
  },

  beforeMount() {
    this.queryToUse = this.lastquery['user'] ? this.lastquery['user'] : this.query
  },

  async mounted () {
    const { dispatch } = this.$store

    await dispatch('company/fetchAll'),
    await dispatch('usertypes/fetchAll')

    if (this.lastquery['user']) {
      for (const [key, value] of Object.entries(this.lastquery['user'])) {
        this.query[key] = value
      }
    }

    this.queryToUse = this.query
  },

  destroyed () {
    const { dispatch } = this.$store

    dispatch('company/cleanState')
    dispatch('usertypes/cleanState')
    dispatch('filtershistory/setQuery', { key: 'user', query: this.query })
  }
}

</script>
